<template>
  <div
    :id="site"
    v-if="page"
  >
    <component
      v-for="c in page.components"
      :is="c.name"
      :key="c.id"
      v-bind="c"
      @sectionChanged="sectionChanged"
    ></component>
  </div>
</template>

<script>
export default {
  name: "brand-page",
  props: ["page", "site"],
  methods: {
    sectionChanged(data) {
      this.$emit("sectionChanged", data);
    }
  },
  components: {
    HeroBanner: () => import("../components/common/HeroBanner"),
    HeroSection: () => import("../components/common/HeroSection"),
    HeroContact: () => import("../components/common/HeroContact"),
    HeroCarousel: () => import("../components/common/HeroCarousel"),
    HeroRegister: () => import("../components/common/HeroRegister")
  }
};
</script>
